export default {
  Title: 'Work History',
  Subtitle: 'Tell us about your previous work experience.',
  EmploymentLabel: 'Employment #{number}',
  EmployerNameLabel: 'Employer Name',
  EmployerNameHelper: 'Name of the company or organization',
  StartDateLabel: 'Start Date',
  StartDateHelper: 'When you started working here',
  EndDateLabel: 'End Date',
  EndDateHelper: 'Leave blank if currently employed',
  CanContactLabel: 'This employer can be contacted as a reference',
  AddEmployerButton: 'Add Employment',
  RemoveEmploymentButton: 'Remove Employment',
  SummaryTitle: 'Employment History Summary (#{count} #{positions}):',
  PositionSingular: 'position',
  PositionPlural: 'positions',
  UnnamedEmployer: 'Unnamed Employer',
  ReferenceAvailable: 'Reference available',
  DatesNotSpecified: 'Dates not specified',
  UntilDate: 'Until #{date}',
  Present: 'Present',
  ClearEndDateButton: 'Clear End Date (Currently Employed)',
  WhenStartedHelper: 'When you started working here',
  LeaveBlankHelper: 'Leave blank if currently employed',
  CanContactReference: 'This employer can be contacted as a reference',
  ReferenceContactInfo: 'Reference Contact Information',
  ReferenceContactInfoHelper: 'Provide contact details for this reference (phone, email, or other)',
  ReferenceContactInfoPlaceholder: 'e.g., Phone: (555) 123-4567, Email: manager@company.com',
  DateFormats: {
    MonthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  },
};
